import type { DescriptorPairType } from '../../../../../../schemas/schemaDiff.schemas';

export function createDescriptorPairLookup(descriptorPairs: DescriptorPairType[]) {
    const pairsById = new Map<string, DescriptorPairType>();
    for (const pair of descriptorPairs) {
        if (pair.referenceDescriptor !== null) {
            pairsById.set(pair.referenceDescriptor, pair);
        }
        if (pair.targetDescriptor !== null) {
            pairsById.set(pair.targetDescriptor, pair);
        }
    }

    return (descriptorId: string): DescriptorPairType => {
        const pair = pairsById.get(descriptorId);
        if (!pair) {
            throw new Error(`Descriptor pair for ${descriptorId} was not found`);
        }
        return pair;
    };
}

export type DescriptorPairLookup = ReturnType<typeof createDescriptorPairLookup>;

export function getDiffDescriptorId(pair: DescriptorPairType): string {
    // The response schema requires at least one side, and the backend prefers the target ID.
    return (pair.targetDescriptor ?? pair.referenceDescriptor)!;
}
